<template>
  <div class="form-list">
    <h3>我的咨询</h3>
    <div class="table-content">
      <table-page :data="tableData" :columns="columns" :currentPage="query.pnum" :pageSize="query.size" :total="total"
        :loading="loading" :border="true" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange"
        @selectionChange="handleSelection">
        <template slot="index" slot-scope="scope">
          <span>{{ scope.index + 1 }}</span>
        </template>
        <template slot="isReply" slot-scope="scope">
          <span>{{ scope.row.isReply == 1 ? "已解答" : "未解答" }}</span>
        </template>
        <!-- <template slot="consultFileVo" slot-scope="scope">
              <span> {{ scope.row. }}</span>
            </template> -->
        <template slot="operation" slot-scope="scope">
          <el-button type="text" size="small" @click="handleReply(scope.row)">详情</el-button>
        </template>
      </table-page>
    </div>
    <Reply v-if="showReply" ref="reply" @closeDialog="closeDialog" />
  </div>
</template>

<script>
  import TablePage from "@/components/table/table-page";
  import Reply from "../technology/reply.vue";
  import {
    getZXInfo,
  } from "@/api/supplyDemand";
  const columns = [
    {
      prop: "index",
      label: "序号",
      width: 80,
      template: true,
    },
    {
      prop: "consultTitle",
      label: "作物类型",
      width: 120,
    },
    {
      prop: "consultDesc",
      label: "问题描述",
    },
    // {
    //   prop: "consultFileVo",
    //   label: "附件",
    //   width: 200,
    //   template: true,
    // },
    {
      prop: "isReply",
      label: "状态",
      width: 100,
      template: true,
    },
    {
      prop: "createTime",
      label: "创建时间",
      width: 200,
    },
    {
      prop: "operation",
      label: "操作",
      width: 120,
      template: true,
    },
  ];

  export default {
    components: { TablePage, Reply },
    data() {
      return {
        // 列表数据
        tableData: [],
        query: {
          current: 1,
          size: 10,
        },
        total: 0,
        // 弹窗
        showReply: false,
        columns: columns,
        loading: false,
      };
    },
    mounted() {
      this.getZXList()
    },
    methods: {
      // 关闭弹框
      closeDialog() {
        this.showReply = false
        this.getZXList()
      },
      dialogClose(val) {
        // 关闭弹窗
        this.dialogVisible = val;
      },
      // 打开弹窗
      handleReply(row) {
        console.log(row, '查看row')
        this.showReply = true;
        this.$nextTick(() => {
          this.$refs.reply.editObj(row, true);
        });

      },
      async getZXList() {
        let params = {
          ...this.query,
        };
        let res = await getZXInfo(params);
        if (res.code == 0 && res.data.total > 0) {
          this.tableData = res.data.records;
          this.total = Number(res.data.total);
        }
      },
      //分页总页数切换
      handleSizeChange(size) {
        this.query = {
          current: 1,
          size: size,
        };
        // this.getList();
        this.getZXList()
      },
      handleSelection(selects) {
        console.log(selects);
      },
      //分页单页切换
      handleCurrentChange(page) {
        this.query.current = page;
        this.getZXList()
        // this.getList();
      },
    }
  };
</script>
<style lang="less"></style>
